import { render, staticRenderFns } from "./SvgSantralComponent.vue?vue&type=template&id=47c9b2e4&scoped=true&"
import script from "./SvgSantralComponent.vue?vue&type=script&lang=js&"
export * from "./SvgSantralComponent.vue?vue&type=script&lang=js&"
import style0 from "./SvgSantralComponent.vue?vue&type=style&index=0&id=47c9b2e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c9b2e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VDivider,VRow})
